import { forwardRef } from "react";
import { useId } from "react";
function SvgRawShareIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20.122 13h3.869c.867 0 1.009.264 1.009 1v13c0 .736-.198 1-1.065 1H8.009C7.142 28 7 27.736 7 27V14c0-.736.142-1 1.01-1h4.037"
      />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M16 19V8"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m16 3 5 6H11l5-6Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawShareIcon);
export default ForwardRef;
